export default function UserProfileActionPanels({ profile }) {
  const {
    t,
    expandedMedia,
    confirmAction,
    confirmMessage,
    confirmActionPending,
    confirmError,
    handleCloseExpandedMedia,
    closeConfirmModal,
    handleConfirmAction,
  } = profile;

  return (
    <>
      {expandedMedia && (
        <div
          className="userprofile-media-overlay"
          onClick={handleCloseExpandedMedia}
        >
          <button
            className="userprofile-media-close"
            onClick={(event) => {
              event.stopPropagation();
              handleCloseExpandedMedia();
            }}
          >
            {"\u00D7"}
          </button>

          {expandedMedia.type === "image" ? (
            <img
              src={expandedMedia.src}
              alt={t("post_media")}
              className="userprofile-media-expanded"
              onClick={(event) => event.stopPropagation()}
            />
          ) : (
            <video
              src={expandedMedia.src}
              controls
              autoPlay
              className="userprofile-media-expanded"
              onClick={(event) => event.stopPropagation()}
            />
          )}
        </div>
      )}

      {confirmAction && (
        <div
          className="userprofile-confirm-overlay"
          onClick={closeConfirmModal}
          role="presentation"
        >
          <div
            className="userprofile-confirm-modal"
            onClick={(event) => event.stopPropagation()}
            role="dialog"
            aria-modal="true"
          >
            <p className="userprofile-confirm-text">{confirmMessage}</p>
            {confirmError ? (
              <p className="userprofile-confirm-error" role="alert">
                {confirmError}
              </p>
            ) : null}

            <div className="userprofile-confirm-actions">
              <button
                type="button"
                className="userprofile-confirm-cancel"
                onClick={closeConfirmModal}
                disabled={confirmActionPending}
              >
                {t("cancel")}
              </button>

              <button
                type="button"
                className="userprofile-confirm-yes"
                onClick={handleConfirmAction}
                disabled={confirmActionPending}
              >
                {t("yes", { defaultValue: "Yes" })}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
